module.exports = __webpack_public_path__ + "img/museu-logo.4a1df6cb.png";